<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="competition-achievements-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">
              &times;
            </span>
          </button>

          <h4 class="modal-title">
            Achievements
          </h4>
        </div>

        <loading-spinner v-if="loading"/>

        <div v-else class="modal-body">
          <table class="table table-striped">
            <thead>
            <tr>
              <th class="col-xs-12">
                Company
              </th>

              <th class="col-xs-6">
                Description
              </th>

              <th class="col-xs-6 text-right">
                Value
              </th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="achievement in achievements">
              <td>
                <router-link :to="'/companies/' + achievement.attributes.company_id" data-dismiss="modal">
                  {{ achievement.attributes.company_name }}
                </router-link>
              </td>

              <td>
                {{ achievement.attributes.description }}
              </td>

              <td class="text-right">
                {{ getFormattedValue(achievement.attributes.value) }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
  components: {LoadingSpinner},

  props: {
    competition: {
      required: true
    },

    competitionTeamId: {
      required: true
    },

    date: {
      required: false
    }
  },

  data() {
    return {
      achievements: null,

      loading: true
    }
  },

  mounted() {
    this.listenForClose()
  },

  watch: {
    date() {
      this.load()
    }
  },

  methods: {
    load() {
      this.loading = true

      http.get('/api/v2/competition-teams/' + this.competitionTeamId + '/dates/' + this.date + '/achievements')
          .then(response => {
            this.achievements = response.data.data

            this.loading = false
          })
    },

    hide() {
      $(this.$el).modal('hide')
    },

    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    reset() {
      this.page = 1
    },

    getFormattedValue(value) {
      if (this.competition.attributes.value_unit === 'number') {
        return this.$options.filters.number(value)
      }

      if (this.competition.attributes.value_unit === 'money') {
        return this.$options.filters.price(value)
      }

      return value
    }
  }
}
</script>
